import { Inject, Injectable } from '@angular/core';
import { Payment, PaymentRepository } from '@infrab4a/connect';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopPaymentService extends BaseConnectService<Payment> {
  constructor(
    @Inject('PaymentRepository')
    private paymentRepository: PaymentRepository
  ) {
    super(paymentRepository);
  }

  async getPaymentsByOrderId(orderId: string): Promise<Payment[]> {
    const result = await this.paymentRepository.find({
      filters: { orderId }
    });
    return result?.data ?? [];
  }
}
